import ShovelIcon from './gps.svg'
import { SPRITE_LAYER } from './ThreeBur3DView'
import { CreateAabb, CreatePositionVectorFromLatLon } from './ThreeUtils'
import * as THREE from 'three'
import { fromLatLon } from 'utm'
import { Location } from './openapi'

export const UTMZONE = 32

let geoSprite: THREE.Sprite
const img = new Image()
img.src = ShovelIcon
export class ThreeLocation {
  private raycaster_ = new THREE.Raycaster()

  public SetGeoPosition(
    geoPosition: GeolocationPosition,
    scene_: THREE.Scene,
    camera_: THREE.Camera,
    cameraOrigin: THREE.Vector2
  ): THREE.Vector3 | undefined {
    if (geoSprite !== undefined) {
      scene_.remove(geoSprite)
    }
    const spritemat: THREE.SpriteMaterial = new THREE.SpriteMaterial({ sizeAttenuation: true })

    const sz = 128 * window.devicePixelRatio // was 64
    const drawcanvas = document.createElement('canvas')
    drawcanvas.width = sz
    drawcanvas.height = sz
    const ctx = drawcanvas.getContext('2d')

    // If no 2d context, we cannot draw a sprite
    if (!ctx) {
      return undefined
    }

    ctx.clearRect(0, 0, sz, sz)

    const radiusMultiplierBigCircle = 0.67
    const lineWidthBigCircle = 20

    const createCircle = (multiplier: number, lineWidth: number) => {
      ctx.beginPath()
      ctx.lineWidth = lineWidth
      ctx.strokeStyle = '#72795a'
      ctx.arc(sz / 2, sz / 2, (sz / 2) * multiplier, 0, 2 * Math.PI)
      ctx.fillStyle = '#72795a'
      ctx.fill()
      ctx.stroke()
    }

    createCircle(radiusMultiplierBigCircle, lineWidthBigCircle)
    ctx.drawImage(img, 0, 0)

    spritemat.map = new THREE.CanvasTexture(drawcanvas)
    spritemat.map.colorSpace = THREE.SRGBColorSpace
    spritemat.map.needsUpdate = true

    spritemat.opacity = 1

    const aabb = CreateAabb(scene_)

    const utmPos = fromLatLon(geoPosition.coords.latitude, geoPosition.coords.longitude, UTMZONE)

    const location: Location = {
      latitude: geoPosition.coords.latitude,
      longitude: geoPosition.coords.longitude,
      easting: utmPos.easting,
      northing: utmPos.northing,
      epsg: 0,
    }

    const position = CreatePositionVectorFromLatLon(location, UTMZONE, aabb, cameraOrigin)

    this.raycaster_.layers.set(0)
    this.raycaster_.camera = camera_
    this.raycaster_.set(new THREE.Vector3(position.x, aabb.max.y + 1, position.y), new THREE.Vector3(0, -1, 0))
    const intersections = this.raycaster_.intersectObject(scene_)

    if (intersections.length > 0) {
      position.z = intersections[0].point.y + 10
    }

    const sprite = new THREE.Sprite(spritemat)
    sprite.renderOrder = 1
    sprite.position.set(position.x, position.z, position.y)
    sprite.rotateZ(90)
    sprite.scale.set(10, 10, 10)
    sprite.name = 'gps'
    sprite.layers.set(SPRITE_LAYER)

    scene_.add(sprite)
    geoSprite = sprite

    // Return the computed position in scene space from the geo position
    return sprite.position.clone()
  }

  public ShowGeoPosition(show: boolean, scene_: THREE.Scene, callback: (render: boolean) => void) {
    if (!show) {
      scene_.remove(geoSprite)
      callback(true)
    }
  }
}
